import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useIntercom } from 'react-use-intercom';
import { AvatarColors } from 'types/profile';
import { useAppDispatch } from 'app/store';
import { routes } from 'app/routing/routesConfig';
import { openIntercomAction } from 'app/store/Mixpanel/slice';
import {
  Menu,
  MenuButton,
  MenuButtonProps,
  MenuItem,
  MenuList,
} from '@chakra-ui/react';
import { ChakraAvatar } from 'app/components/Core';
import { getMobileOperatingSystem } from 'app/utils/utils';

interface ProfileButtonProps {
  avatar?: string;
  signOut: () => void;
  initials?: string;
  colors?: AvatarColors;
}

const MenuButtonComponent = ({ children, ...props }: MenuButtonProps) => (
  <MenuButton
    transition="none"
    borderRadius={8}
    sx={{ WebkitAppRegion: 'no-drag' }}
    data-testid="profile-dropdown"
    height={9}
    {...props}
  >
    {children}
  </MenuButton>
);

export const ProfileButton: FC<ProfileButtonProps> = ({
  avatar,
  signOut,
  initials,
  colors,
}) => {
  const isNotMobileOS = !getMobileOperatingSystem();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { show } = useIntercom();

  return (
    <Menu
      preventOverflow={false}
      gutter={4}
      placement="bottom-end"
      flip={false}
      autoSelect={isNotMobileOS}
    >
      <MenuButtonComponent mr={2}>
        <ChakraAvatar
          src={avatar}
          initials={initials}
          colors={colors}
          size="sm"
        />
      </MenuButtonComponent>
      <MenuList
        padding={0}
        minWidth="112px"
        sx={{ WebkitAppRegion: 'no-drag' }}
      >
        <MenuItem
          data-testid="profile"
          onClick={() => {
            navigate(routes.profile.path);
          }}
        >
          Profile
        </MenuItem>
        <MenuItem
          data-testid="settings"
          onClick={() => {
            navigate(routes.settings.path);
          }}
        >
          Settings
        </MenuItem>
        <MenuItem
          data-testid="help"
          onClick={() => {
            show();
            dispatch(openIntercomAction());
          }}
        >
          Help
        </MenuItem>
        <MenuItem
          borderTop="1px solid"
          borderColor="borderBase"
          data-testid="log out"
          onClick={signOut}
        >
          Log Out
        </MenuItem>
      </MenuList>
    </Menu>
  );
};
